import { useState, useEffect } from 'react';

// Imperative confirm dialog styled to match the app instead of the browser's
// native confirm() popup. Usage: if (!(await confirmDialog('Delete this?', { danger: true }))) return;
// Mount <ConfirmDialogHost /> once, near the top of the app (see App.jsx).

let showFn = null;

export function confirmDialog(message, options = {}) {
  return new Promise((resolve) => {
    if (showFn) showFn({ message, options, resolve });
    else resolve(window.confirm(message)); // safety net if the host isn't mounted for some reason
  });
}

export function ConfirmDialogHost() {
  const [state, setState] = useState(null);

  useEffect(() => {
    showFn = (s) => setState(s);
    return () => { showFn = null; };
  }, []);

  if (!state) return null;
  const { message, options, resolve } = state;
  const close = (result) => { setState(null); resolve(result); };

  return (
    <div className="modal-overlay" onClick={() => close(false)}>
      <div className="modal" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{options.title || 'Please confirm'}</h3>
        </div>
        <p style={{ fontSize: 14, color: 'var(--text)', lineHeight: 1.55, margin: '4px 0 20px' }}>
          {message}
        </p>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => close(false)}>
            {options.cancelText || 'Cancel'}
          </button>
          <button className={`btn ${options.danger ? 'btn-danger' : 'btn-success'}`} onClick={() => close(true)} autoFocus>
            {options.confirmText || 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}
